<div class="sol-shortcut">
  @for (item of items$(); track itemIndex; let itemIndex = $index) {
    <div class="sol-shortcut-item">
      @if (!!item.icon) {
        <sol-icon [name]="item.icon" />
      } @else if (!!item.text) {
        {{ item.text }}
      }
    </div>
  }
</div>
